window.$ = window.jQuery;
/* Angular Dependencies */
import angular from 'angular';
let uiRouter = require("@uirouter/angularjs").default;
import '@uirouter/angularjs/release/stateEvents';
import 'angular-file-upload';
import angularLocalePT from "angular-i18n/pt-pt";
import ngResource from "angular-resource";
import ngSanitize from "angular-sanitize";
import textAngular from "textangular";
/* Drag and Drop stuff */
require('webpack-jquery-ui/sortable');
require('angular-ui-sortable');
/* Template modules */
import config from './app.config';
import {ApplicationInterceptor} from "./app.interceptor";
import { ngTableModule } from 'ng-table/bundles/ng-table';
// import ngChart from "angular-chart.js";
// require('chart.js');
/* Client Modules */
import lbServices from './modules/loopback/lbServices';
import Interface from './modules/interface';
import Authentication from './modules/authentication';
import Administration from './modules/administration';
import Authorization from './modules/authorization';

import Investigador from './modules/investigator';
import Revista from './modules/revista';
import Orientacao from './modules/orientacao';
import Evento from './modules/evento';
import Network from './modules/network';
import Produto from './modules/produto';
import Painel from './modules/painel';
import Formacao from './modules/formacao';
import Servico from './modules/servico';
import Projeto from './modules/projeto';
import Publicacao from './modules/publicacao';
import Noticia from './modules/noticia';
import Oportunidade from './modules/oportunidade';
import Indicadores from './modules/indicadores';
require('ui-select/dist/select.min.css');
import uiSelect from "ui-select";

require('@mdi/font/css/materialdesignicons.min.css');
require('textangular/dist/textAngular.css');

// Set moment locale to Portugal globally. It works :)
moment.locale('pt');
/* App global inject */
let app = angular.module('app', [
  uiRouter,
  'ui.router.state.events',
  ngResource,
  ngSanitize,
  textAngular,
  angularLocalePT,
  'angularFileUpload',
  'ui.sortable',
  uiSelect,
  ngTableModule.name,
  // ngChart,
  lbServices,
  Interface,
  Authentication,
  Authorization,
  Administration,
  Investigador,
  Revista,
  Orientacao,
  Evento,
  Network,
  Produto,
  Painel,
  Formacao,
  Servico,
  Projeto,
  Publicacao,
  Noticia,
  Oportunidade,
  Indicadores
]);

app.config(config);
app.run(ApplicationInterceptor);
app.run(['ngTableDefaults', function (ngTableDefaults) {
  ngTableDefaults.params.setPager = false;
  ngTableDefaults.settings.counts = [10, 25, 50, 100];
  ngTableDefaults.params.page = 1;
}]);

// UI-Select config
app.config(['uiSelectConfig', function(uiSelectConfig) {
  uiSelectConfig.theme = 'bootstrap';
  uiSelectConfig.resetSearchInput = false;
  uiSelectConfig.skipFocusser = true;
}]);

// TextAngular config
app.config(['$provide', function($provide) {
  $provide.decorator('taOptions', ['$delegate', function(taOptions) {
    // $delegate is the taOptions we are decorating
    // here we override the default toolbars and classes specified in taOptions.
    taOptions.forceTextAngularSanitize = false; // set false to allow the textAngular-sanitize provider to be replaced
    taOptions.keyMappings = []; // allow customizable keyMappings for specialized key boards or languages
    taOptions.toolbar = [
      ['bold', 'italics', 'underline'], ['ul', 'outdent', 'indent'], ['redo', 'undo', 'clear'], ['html'],
    ];
    taOptions.classes = {
      focussed: '',
      toolbar: 'btn-toolbar',
      toolbarGroup: 'btn-group',
      toolbarButton: 'btn btn-xs btn-default pmd-btn-flat pmd-ripple-effect',
      toolbarButtonActive: 'active',
      disabled: 'disabled',
      textEditor: 'form-control',
      htmlEditor: 'form-control',
    };
    return taOptions; // whatever you return will be the taOptions
  }]);
  // Replace css icons
  $provide.decorator('taTools', ['$delegate', function(taTools) {
    taTools.bold.iconclass = ' mdi mdi-format-bold';
    taTools.italics.iconclass = 'mdi mdi-format-italic';
    taTools.underline.iconclass = ' mdi mdi-format-underline';
    taTools.ul.iconclass = ' mdi mdi-format-list-bulleted';
    taTools.indent.iconclass = ' mdi mdi-format-indent-increase';
    taTools.outdent.iconclass = ' mdi mdi-format-indent-decrease';
    taTools.undo.iconclass = ' mdi mdi-undo';
    taTools.redo.iconclass = ' mdi mdi-redo';
    taTools.clear.iconclass = ' mdi mdi-format-clear';
    taTools.html.iconclass = ' mdi mdi-code-tags';
    return taTools;
  }]);
}]);
